"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _couponExpand = require("@/api/activity/couponExpand");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ExpandAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: String,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        console.log('newId', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.fetchActDetail(newId);
        }
        ;
        console.log('actId', newId);
      }
    }
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏

      fileList: [],
      fileList2: [],
      time: [],
      typeName1: '',
      typeName2: '',
      typeName3: '',
      typeName4: '',
      typeName5: '',
      form: {
        begType: 1,
        activityName: '',
        couponStartId: '',
        couponEndId: '',
        newCouponId: '',
        oldCouponId: '',
        newCouponCount: '',
        oldCouponCount: '',
        oldReceiveCount: '',
        oldCouponTotalCount: '',
        newCouponTotalCount: '',
        isMember: 0,
        gradeId: [],
        isQw: 0,
        shareCouponId: '',
        registerShareImg: '',
        registerShareTitle: '',
        registerShareDesc: '',
        orderShareImg: '',
        orderShareTitle: '',
        orderShareDesc: '',
        status: 1
      },
      rules: {
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        couponStartId: [{
          required: true,
          message: '请选择可膨胀券',
          trigger: 'change'
        }],
        couponEndId: [{
          required: true,
          message: '请选择膨胀后的券',
          trigger: 'change'
        }],
        shareCouponId: [{
          required: true,
          message: '请选择被分享人券',
          trigger: 'change'
        }],
        newCouponId: [{
          required: true,
          message: '请选择新人券',
          trigger: 'change'
        }],
        oldCouponId: [{
          required: true,
          message: '请选择老用户券',
          trigger: 'change'
        }],
        registerShareTitle: [{
          required: true,
          message: '请输入膨胀分享标题',
          trigger: 'blur'
        }],
        // registerShareDesc: [{ required: true, message: '请输入膨胀分享路径', trigger: 'blur' }],
        orderShareTitle: [{
          required: true,
          message: '请输入用券分享标题',
          trigger: 'blur'
        }],
        // orderShareDesc: [{ required: true, message: '请输入用券分享路径', trigger: 'blur' }],
        registerShareImg: [{
          required: true,
          message: '请上传膨胀享图片',
          trigger: 'change'
        }],
        orderShareImg: [{
          required: true,
          message: '请上传用券分享图片',
          trigger: 'change'
        }],
        oldReceiveCount: [{
          required: true,
          message: '请输入老用户每月领取上限',
          trigger: 'blur'
        }]
      },
      couponOptions1: [],
      couponOptions2: [],
      couponOptions3: [],
      couponOptions4: [],
      couponOptions5: [],
      couponLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    fetchActDetail: function fetchActDetail(id) {
      var _this = this;
      var id2 = id;
      if (id.endsWith('_copy')) {
        id2 = id.replace('_copy', '');
      }
      (0, _couponExpand.getDetail)(id2).then(function (res) {
        if (res.code !== 200) return;
        _this.form = res.data; // 假设返回的数据结构是 { data: {...} }

        _this.form.newCouponId = String(_this.form.newCouponId);
        _this.form.oldCouponId = String(_this.form.oldCouponId);
        _this.fetchCoupons4(_this.form.newCouponId);
        _this.fetchCoupons5(_this.form.oldCouponId);
        if (id.endsWith('_copy')) {
          _this.form.id = null; // 复制新增时，清空ID
          _this.form.couponStartId = String(_this.form.couponStartId);
          _this.form.couponEndId = String(_this.form.couponEndId);
          _this.form.shareCouponId = String(_this.form.shareCouponId);
          _this.fetchCoupons1(_this.form.couponStartId);
          _this.fetchCoupons2(_this.form.couponEndId);
          _this.fetchCoupons3(_this.form.shareCouponId);
        } else {
          (0, _couponExpand.getCouponByThirdId)(_this.form.couponStartId).then(function (response) {
            _this.typeName1 = response.data.typeName;
          }).catch(function (error) {
            console.error('获取失败:', error);
          });
          (0, _couponExpand.getCouponByThirdId)(_this.form.couponEndId).then(function (response) {
            _this.typeName2 = response.data.typeName;
          }).catch(function (error) {
            console.error('获取失败:', error);
          });
          (0, _couponExpand.getCouponByThirdId)(_this.form.shareCouponId).then(function (response) {
            _this.typeName3 = response.data.typeName;
          }).catch(function (error) {
            console.error('获取失败:', error);
          });

          // getCouponByThirdId(this.form.newCouponId).then(response => {
          //     this.typeName4 = response.data.typeName
          // }).catch(error => {
          //     console.error('获取失败:', error)
          // })
          // getCouponByThirdId(this.form.oldCouponId).then(response => {
          //     this.typeName5 = response.data.typeName
          // }).catch(error => {
          //     console.error('获取失败:', error)
          // })
        }
        _this.form.gradeId = _this.form.gradeId ? _this.form.gradeId.split(',').map(Number) : [];
        if (_this.form.begType == 1) {
          _this.time = [];
        } else {
          var date = new Date(res.data.begDate);
          var date2 = new Date(res.data.endDate);
          var year = date.getFullYear();
          var month = _this.pad(date.getMonth() + 1);
          var day = _this.pad(date.getDate());
          var hours = _this.pad(date.getHours());
          var mins = _this.pad(date.getMinutes());
          var secs = _this.pad(date.getSeconds());
          var begDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
          var year2 = date2.getFullYear();
          var month2 = _this.pad(date2.getMonth() + 1);
          var day2 = _this.pad(date2.getDate());
          var hours2 = _this.pad(date2.getHours());
          var mins2 = _this.pad(date2.getMinutes());
          var secs2 = _this.pad(date2.getSeconds());
          var endDate = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
          _this.time = [begDate, endDate];
        }
        _this.form.begDate = null;
        _this.form.endDate = null;
        _this.fileList = [{
          name: '膨胀券分享图',
          url: res.data.registerShareImg
        }];
        _this.fileList2 = [{
          name: '用券分享图',
          url: res.data.orderShareImg
        }];
        console.log(" res", res);
      });
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this2 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this2.couponOptions1 = res.records || [];
      }).finally(function () {
        _this2.couponLoading = false;
      });
    },
    fetchCoupons2: function fetchCoupons2(query) {
      var _this3 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this3.couponOptions2 = res.records || [];
      }).finally(function () {
        _this3.couponLoading = false;
      });
    },
    fetchCoupons3: function fetchCoupons3(query) {
      var _this4 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this4.couponOptions3 = res.records || [];
      }).finally(function () {
        _this4.couponLoading = false;
      });
    },
    fetchCoupons4: function fetchCoupons4(query) {
      var _this5 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this5.couponOptions4 = res.records || [];
      }).finally(function () {
        _this5.couponLoading = false;
      });
    },
    fetchCoupons5: function fetchCoupons5(query) {
      var _this6 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this6.couponOptions5 = res.records || [];
      }).finally(function () {
        _this6.couponLoading = false;
      });
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this7 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _taskConfig.uploadImg)(formData).then(function (res) {
        var url = res.data; // 按实际调整
        // 更新展示地址
        _this7.form.registerShareImg = url;

        // 替换上传组件的 fileList（最多一张）
        _this7.fileList = [{
          name: '膨胀券分享图',
          url: url
        }];
        _this7.$message.success('上传成功');
      }).catch(function () {
        _this7.$message.error('上传失败');
      });
    },
    handleCustomUpload2: function handleCustomUpload2(_ref2) {
      var _this8 = this;
      var file = _ref2.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _taskConfig.uploadImg)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        // 更新展示地址
        _this8.form.orderShareImg = url;

        // 替换上传组件的 fileList（最多一张）
        _this8.fileList2 = [{
          name: '用券分享图',
          url: url
        }];
        _this8.$message.success('上传成功');
      }).catch(function () {
        _this8.$message.error('上传失败');
      });
    },
    handleUploadRemove: function handleUploadRemove(index) {
      if (index == 1) {
        this.fileList = [];
        this.form.registerShareImg = '';
      } else {
        this.fileList2 = [];
        this.form.orderShareImg = '';
      }
    },
    handleSubmit: function handleSubmit() {
      var _this9 = this;
      // this.loading = true; // 开始加载
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var formData;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  _context.next = 1;
                  break;
                }
                _this9.loading = false; // 停止加载
                return _context.abrupt("return");
              case 1:
                if (!(!_this9.time[0] && _this9.form.begType == 0)) {
                  _context.next = 2;
                  break;
                }
                _this9.$message.error('请选择活动时间');
                return _context.abrupt("return");
              case 2:
                formData = _this9.form;
                formData.gradeId = _this9.form.isMember == 1 ? _this9.form.gradeId.join(',') : '';
                if (_this9.form.begType == 1) {
                  formData.startDateStr = null;
                  formData.endDateStr = null;
                } else {
                  formData.startDateStr = _this9.time[0];
                  formData.endDateStr = _this9.time[1];
                }
                console.log('formData', formData);
                _this9.loading = true; // 开始加载

                (0, _couponExpand.addAct)(formData).then(function (res) {
                  if (res.code === 200) {
                    _this9.loading = false; // 停止加载
                    _this9.$message.success('操作成功');
                    _this9.handleClose();
                  } else {
                    _this9.loading = false; // 停止加载
                    _this9.$message.error(res.message);
                  }
                });
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.$emit('saved'); // 通知父组件刷新列表
      // this.$emit('update:visible', false);
    }
  }
};